mutation UpdateImpactMeasurementItem(
  $impactMeasurementItemId: ID!
  $impactMeasurementItemInput: ImpactMeasurementItemInput!
) {
  updateImpactMeasurementItem(
    input: {
      impactMeasurementItemId: $impactMeasurementItemId
      impactMeasurementItemInput: $impactMeasurementItemInput
    }
  ) {
    impactMeasurementItem {
      id
    }
  }
}
